import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { countryList } from "../utils/countryCode";
import "font-awesome/css/font-awesome.min.css";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../utils/loader/loader";
import ToastMessage from "../utils/toasts/toastMessage";
import { signup } from "../Redux/authentication/auth.action";

const Signup = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [form, setForm] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    countryCode: "IN",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // hidden by default

const togglePasswordVisibility = () => setShowPassword(!showPassword);
const toggleConfirmPasswordVisibility = () =>
  setShowConfirmPassword(!showConfirmPassword);

const passwordValidations = [
  { id: 1, text: "Minimum characters 6", valid: form.password.length >= 6 },
  { id: 2, text: "One uppercase character", valid: /[A-Z]/.test(form.password) },
  { id: 3, text: "One lowercase character", valid: /[a-z]/.test(form.password) },
  {
    id: 4,
    text: "One special character",
    valid: /[!@#$%^&*(),.?":{}|<>]/.test(form.password),
  },
  { id: 5, text: "One number", valid: /\d/.test(form.password) },
];

const validateField = (name, value, currentForm) => {
  switch (name) {
    case "fName":
      return value.trim() ? "" : "First name is required.";
    case "lName":
      return value.trim() ? "" : "Last name is required.";
    case "email":
      if (!value.trim()) return "Email is required.";
      if (!/^\S+@\S+\.\S+$/.test(value)) return "Email format is invalid.";
      return "";
   case "password":
  if (!value) return "Password is required.";
  if (value.length < 6) return "Password must be at least 6 characters.";
  if (!/[A-Z]/.test(value)) return "Password must contain an uppercase character.";
  if (!/[a-z]/.test(value)) return "Password must contain a lowercase character.";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) return "Password must contain a special character.";
  if (!/\d/.test(value)) return "Password must contain a number.";
  return "";
    case "confirmPassword":
      if (!value) return "Please confirm your password.";
      if (value !== currentForm.password) return "Passwords do not match.";
      return "";
    case "mobile": {
      if (!value.trim()) return "Mobile number is required.";
      const phoneNumber = parsePhoneNumberFromString(value, currentForm.countryCode);
      if (!phoneNumber || !phoneNumber.isValid())
        return "Invalid mobile number for selected country.";
      return "";
    }
    default:
      return "";
  }
};

const validateForm = () => {
  const fieldNames = ["fName", "lName", "email", "password", "confirmPassword", "mobile"];
  const newErrors = {};

  fieldNames.forEach((name) => {
    const error = validateField(name, form[name], form);
    if (error) newErrors[name] = error;
  });

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const handleValueChange = (e) => {
  const { name, value } = e.target;
  const updatedForm = { ...form, [name]: value };
  setForm(updatedForm);

  setErrors((prev) => ({
    ...prev,
    [name]: validateField(name, value, updatedForm),
    ...(name === "password" && updatedForm.confirmPassword
      ? {
          confirmPassword: validateField(
            "confirmPassword",
            updatedForm.confirmPassword,
            updatedForm
          ),
        }
      : {}),
  }));
};

const confirmPasswordBorderStyle = form.confirmPassword
  ? {
      borderColor:
        form.confirmPassword === form.password ? "green" : "red",
    }
  : {};

  // const togglePasswordVisibility = () => {
  //   setShowPassword(!showPassword);
  // };

  // const handleValueChange = (e) => {
  //   const { name, value } = e.target;
  //   setForm((prev) => ({ ...prev, [name]: value }));
  //   setErrors((prev) => ({ ...prev, [name]: "" }));
  // };

  // const validate = () => {
  //   const newErrors = {};

  //   if (!form.fName.trim()) newErrors.fName = "First name is required.";
  //   if (!form.lName.trim()) newErrors.lName = "Last name is required.";

  //   if (!form.email.trim()) {
  //     newErrors.email = "Email is required.";
  //   } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
  //     newErrors.email = "Email format is invalid.";
  //   }

  //   if (!form.password) {
  //     newErrors.password = "Password is required.";
  //   } else if (form.password.length < 6) {
  //     newErrors.password = "Password must be at least 6 characters.";
  //   }

  //   if (!form.confirmPassword) {
  //     newErrors.confirmPassword = "Please confirm your password.";
  //   } else if (form.confirmPassword !== form.password) {
  //     newErrors.confirmPassword = "Passwords do not match.";
  //   }
  //   if (!form.mobile.trim()) {
  //     newErrors.mobile = "Mobile number is required.";
  //   } else {
  //     const phoneNumber = parsePhoneNumberFromString(
  //       form.mobile,
  //       form.countryCode
  //     );
  //     if (!phoneNumber || !phoneNumber.isValid()) {
  //       newErrors.mobile = "Invalid mobile number for selected country.";
  //     }
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleSubmit = async () => {
    setLoading(true);
    
    if (!validateForm()) {
      setLoading(false);
      setToastState({
        show: true,
        message: "Please fill in all required fields.",
        type: "error",
      });
      return;
    }

    const payload = {
      first_name: form.fName,
      last_name: form.lName,
      email: form.email,
      phone_number: form.mobile,
      password: form.password,
      confirm_password: form.confirmPassword,
    };

    const result = await dispatch(signup(payload));
    if (result.success) {
      const token = localStorage.getItem("access_token");
      if (token) {
        setToastState({
          show: true,
          message: "account created successfully",
          type: "success",
        });
        setTimeout(() => {
          nav("/");
        }, 500);
      } else {
        setToastState({
          show: true,
          message: "Token missing after signup",
          type: "error",
        });
      }
    } else {
      setToastState({
        show: true,
        message: result.message || "Signup failed! Try again.",
        type: "error",
      });
    }

    setLoading(false);
  };

  const selectedCountry =
    countryList.find((c) => c.code === form.countryCode) || countryList[0];

  return (
    <section className="auth-main">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="w-100 auth-content auth-content--signup">
              <div className="pt-4 auth-content__graphics">
                <img
                  src="./assets/images/inner-pages/auth-side-image.png"
                  alt=""
                  className="main-img"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-prop01.png"
                  alt=""
                  className="anim-up-down side-prop side-prop01"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-prop02.png"
                  alt=""
                  className="anim-up-down side-prop side-prop02"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-shield03.png"
                  alt=""
                  className="anim-up-down side-prop side-prop03"
                />
              </div>
              <img
                src="./assets/images/JigyaasuBlackLogo.svg"
                alt=""
                className="logo-img"
              />
              <div className="auth-content__right auth-content__right--signup">
                <div className="ff-poppins curved-block curved-block">
                  <div className="top-white"></div>
                  <div className="middle-white">
                    <h1 className="fw700 fz56 primaryText">
                      Create an account
                    </h1>
                    <p className="fz20">
                      Create your account it take than a minute
                    </p>
                    <div className="middle-white__inner">
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label htmlFor="" className="fw500 fz16 label">
                              First Name
                            </label>
                            <input
                              type="email"
                              className="fz16 form-control"
                              // defaultValue="John"
                              name="fName"
                              value={form?.fName}
                              onChange={handleValueChange}
                              placeholder="First Name"
                            />
                            {errors.fName && (
                              <div className="text-danger fz12">
                                {errors.fName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label htmlFor="" className="fw500 fz16 label">
                              Last Name
                            </label>
                            <input
                              type="email"
                              className="fz16 form-control"
                              defaultValue="Doe"
                              name="lName"
                              value={form?.lName}
                              onChange={handleValueChange}
                              placeholder="Last Name"
                            />
                            {errors.lName && (
                              <div className="text-danger fz12">
                                {errors.lName}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" className="fw500 fz16 label">
                          Email
                        </label>
                        <input
                          type="email"
                          className="fz16 form-control"
                          defaultValue="jonedoe02@gmail.com"
                          name="email"
                          value={form?.email}
                          onChange={handleValueChange}
                          placeholder="Email"
                        />
                        {errors.email && (
                          <div className="text-danger fz12">{errors.email}</div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label htmlFor="" className="fw500 fz16 label">
                              Password
                            </label>
                            <div style={{ position: "relative" }}>
                              <input
                                type={showPassword ? "password" : "text" }
                                className="fz16 form-control"
                                name="password"
                                value={form?.password}
                                onChange={handleValueChange}
                                placeholder="*****"
                              />
                              <i
                                className={`fa ${
                                  showPassword ?  "fa-eye-slash": "fa-eye"
                                }`}
                                onClick={togglePasswordVisibility}
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                }}
                              ></i>
                            </div>
                            {errors.password && (
                              <div className="text-danger fz12">
                                {errors.password}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-12 col-md-6">
                          <div className="form-group">
                            <label htmlFor="" className="fw500 fz16 label">
                              Confirm Password
                            </label>
                            <input
                              type="password"
                              className="fz16 form-control"
                              name="confirmPassword"
                              value={form?.confirmPassword}
                              onChange={handleValueChange}
                              placeholder="******"
                            />
                            {errors.confirmPassword && (
                              <div className="text-danger fz12">
                                {errors.confirmPassword}
                              </div>
                            )}
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6">
  <div className="form-group">
    <label htmlFor="" className="fw500 fz16 label">
      Confirm Password
    </label>
    <div style={{ position: "relative" }}>
      <input
        type={showConfirmPassword ? "text" : "password"}
        className="fz16 form-control"
        name="confirmPassword"
        value={form?.confirmPassword}
        onChange={handleValueChange}
        placeholder="******"
        style={confirmPasswordBorderStyle}
      />
      <i
        className={`fa ${
          showConfirmPassword ? "fa-eye" : "fa-eye-slash"
        }`}
        onClick={toggleConfirmPasswordVisibility}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      ></i>
    </div>
    {errors.confirmPassword && (
      <div className="text-danger fz12">{errors.confirmPassword}</div>
    )}
  </div>
</div>
                      </div>
                      <div className="mb-0 form-group">
                        <label className="fw500 fz16 label">Phone Number</label>
                        <div className="px-0 input-number">
                          <div className="dropdown">
                            <button
                              className="btn dropdown-toggle dd-flag"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span className="country-code">
                                {selectedCountry?.dial_code}
                              </span>
                            </button>
                            <ul className="dropdown-menu">
                              {countryList?.map((c) => (
                                <li key={c.code}>
                                  <a
                                    href="#"
                                    className="dropdown-item"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleValueChange({
                                        target: {
                                          name: "countryCode",
                                          value: c.code,
                                        },
                                      });
                                    }}
                                  >
                                    {c.name} ({c.dial_code})
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="sep" />
                          <input
                            type="text"
                            className="fz16 fw400 grayText"
                            name="mobile"
                            value={form.mobile}
                            onChange={handleValueChange}
                            // placeholder={`${selectedCountry.dial_code} 312 457 7890`}
                            placeholder="312 457 7890"
                          />
                        </div>
                        {errors.mobile && (
                          <div className="text-danger fz12">
                            {errors.mobile}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="bottom-white">
                    <div className="bottom-white__left">
                      <p className="outer-statement">
                        Already have an account?
                        <a
                          href="javascript:void(0)"
                          className="fw500 m-1"
                          onClick={() => nav("/")}
                        >
                          Sign in
                        </a>
                      </p>
                      {/* <div className="fw500 grayText title-row">
                        Or Sign up with
                      </div>
                      <ul className="list-inline m-0 social-icons">
                        <li>
                          <a href="#" className="">
                            <img
                              src="./assets/images/inner-pages/icons/icon-google.svg"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#" className="">
                            <img
                              src="./assets/images/inner-pages/icons/icon-fb.svg"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a href="#" className="">
                            <img
                              src="./assets/images/inner-pages/icons/icon-insta.svg"
                              alt=""
                            />
                          </a>
                        </li>
                      </ul> */}
                    </div>
                    <div className="bottom-white__right">
                      <button
                        className="btn btn-solid btn-solid--dark btn-auth"
                        onClick={handleSubmit}
                      >
                        <span className="fw500">Sign Up</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </section>
  );
};

export default Signup;
